import { Button, Stack, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface ConnectionErrorScreenProps {
    onRetry: () => void;
}

export default function ConnectionErrorScreen({ onRetry }: ConnectionErrorScreenProps) {
    const { t } = useTranslation('notifications');

    return (
        <div className="relative w-full h-dvh flex flex-col justify-center items-center bg-page">
            <Stack align="center" gap="md" maw={420} px="md">
                <Text c="var(--fg)" fw={600} fz="lg" ta="center">
                    {t('connection.title')}
                </Text>
                <Text c="dimmed" fz="sm" ta="center">
                    {t('connection.message')}
                </Text>
                <Button
                    variant="default"
                    leftSection={<IconRefresh size={18} />}
                    onClick={onRetry}
                >
                    {t('connection.retry')}
                </Button>
            </Stack>
        </div>
    );
}
